import type { RouterConfig } from '@nuxt/schema'

export default <RouterConfig>{
  // The store is imported lazily on purpose: a static import puts this module into the
  // `#build/route-rules.mjs` -> `#build/router.options.mjs` -> store -> nuxt composables
  // import cycle, which leaves `_routeRulesMatcher` in the temporal dead zone at startup.
  async scrollBehavior(to) {
    const { useAppIndexStore } = await import('@base/stores/indexStore')
    const indexStore = useAppIndexStore()
    const savedPosition = indexStore.state.scrollPos[to.path]
    if (savedPosition) {
      return savedPosition
    }
    else {
      return {
        top: 0,
      }
    }
  },
}
